import { GlobalState } from '../../actions';

const roundWinnersSelector = (state: GlobalState) => state.roundWinners;

export const roundWinnersEntitySelector = (state: GlobalState) => roundWinnersSelector(state).winners;